import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Text from '../../base/Text';

const Pill = styled(Text).attrs({
  inline: true,
  lineHeight: '15px',
  noWrap: true,
  size: 'xsmall',
  textAlign: 'center',
})`
  height: 15px;
  padding: 0 8px;
  background-color: ${({ bgColor, theme }) =>
    bgColor ? bgColor : `${theme.colors.primaryBase}`};
  border-radius: 8px;
  color: ${({ color, theme }) =>
    color ? color : `${theme.colors.background}`};
  transition: background-color 0.3s;
`;

/**
 *
 * @param {string} [bgColor] - background color of the notification
 * @param {string} [color] - text color of the notification
 * @param {number} counter - number of new notifications
 *
 */
export const Badge = ({ bgColor, color, counter }) => (
  <Pill bgColor={bgColor} color={color}>
    {counter}
  </Pill>
);

Badge.propTypes = {
  bgColor: PropTypes.string,
  color: PropTypes.string,
  counter: PropTypes.number.isRequired,
};

export default Badge;
